import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ConsultationModal from './components/ConsultationModal';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Facility from './pages/Facility';
import Team from './pages/Team';
import PatientFamily from './pages/PatientFamily';
import Resources from './pages/Resources';
import ResourceDetail from './pages/ResourceDetail';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

export default function App() {
  const [isConsultationOpen, setIsConsultationOpen] = useState(false);

  const openConsultation = () => setIsConsultationOpen(true);
  const closeConsultation = () => setIsConsultationOpen(false);

  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-white text-[#18323A] selection:bg-[#0F766E] selection:text-white">
        
        {/* Navigation Bar */}
        <Navbar onOpenConsultation={openConsultation} />

        {/* Main Routed Content */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home onOpenConsultation={openConsultation} />} />
            <Route path="/about" element={<About onOpenConsultation={openConsultation} />} />
            <Route path="/services" element={<Services onOpenConsultation={openConsultation} />} />
            <Route path="/services/:serviceId" element={<ServiceDetail onOpenConsultation={openConsultation} />} />
            <Route path="/facility" element={<Facility onOpenConsultation={openConsultation} />} />
            <Route path="/team" element={<Team onOpenConsultation={openConsultation} />} />
            <Route path="/patient-family" element={<PatientFamily onOpenConsultation={openConsultation} />} />
            <Route path="/resources" element={<Resources onOpenConsultation={openConsultation} />} />
            <Route path="/resources/:resourceId" element={<ResourceDetail onOpenConsultation={openConsultation} />} />
            <Route path="/contact" element={<Contact onOpenConsultation={openConsultation} />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        {/* Global Consultation Modal */}
        <ConsultationModal
          isOpen={isConsultationOpen}
          onClose={closeConsultation}
        />

        {/* Global Multi-Column Footer */}
        <Footer onOpenConsultation={openConsultation} />
      </div>
    </Router>
  );
}
